// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatProjectsPageCard-modulecard__Oouhx AIButtonContainedGrey-moduleaiButtonContainedGrey__DeVYQ";
var _2 = "GretaAIChatProjectsPageCard-modulehead__vnvcd";
var _3 = "GretaAIChatProjectsPageCard-moduleicon__A8K9Z IconNG-moduleiconContainer__SxWZ0";
var _4 = "GretaAIChatProjectsPageCard-moduleitem__qzM_Q";
var _5 = "GretaAIChatProjectsPageCard-modulemenu__eKTxh GretaAIChatIconButton-moduleiconButton__vHrJi";
var _6 = "GretaAIChatProjectsPageCard-modulemeta__e4_wp";
var _7 = "GretaAIChatProjectsPageCard-modulename__dIkFP GretaAIChatProjectName-modulename__G5oqH";
var _8 = "GretaAIChatProjectsPageCard-modulescope__S3Ux6";
export { _1 as "card", _2 as "head", _3 as "icon", _4 as "item", _5 as "menu", _6 as "meta", _7 as "name", _8 as "scope" }
